import { Injectable } from '@angular/core';
import { ReportesRequestService } from './request/reportes-request.service';

@Injectable({
  providedIn: 'root'
})
export class ServicioAdmisionesService {

  constructor(private requestUrl: ReportesRequestService) { }

  async getAdmision(codigo: string, uncoAdmision: number) {
    try {
      const request = await this.requestUrl.getRequest(
        'admision',
        [ codigo,{ 'uncoAdmision' : uncoAdmision }]
      );
      return request;
    } catch(e) {
      console.error(`ServicioAdmisionesService.getAdmision() : ${e}`);
    }
    return null;
  }

  async getSuministros(codigo: string, uncoAdmision: number) {
    try {
      const request = await this.requestUrl.getRequest(
        'admision/suministros',
        [ codigo,{ 'uncoAdmision' : uncoAdmision }]
      );
      return request;
    } catch(e) {
      console.error(`ServicioAdmisionesService.getSuministros() : ${e}`);
    }
    return null;
  }

  async getConceptos(codigo: string, uncoAdmision: number) {
    try {
      const request = await this.requestUrl.getRequest(
        'admision/conceptos',
        [ codigo,{ 'uncoAdmision' : uncoAdmision }]
      );
      return request;
    } catch(e) {
      console.error(`ServicioAdmisionesService.getConceptos() : ${e}`);
    }
    return null;
  }

  async getAdmisionesAbiertas(codigo: string, fechaInicial: number, fechaFinal: number,
    sedes: string, usuariosRealiza: string, usuariosModifica: string) {
      try {
        const request = await this.requestUrl.getRequest(
          'admision/abiertas',
          [ codigo,
          {
            'fechaInicial' : fechaInicial,
            'fechaFinal' : fechaFinal,
            'sedes' : sedes,
            'usuariosRealiza' : usuariosRealiza,
            'usuariosModifica' : usuariosModifica
          }]
        )
        return request;
      } catch(e) {
        console.error(`ServicioAdmisionesAbiertasService.getAdmisionesAbiertas() : ${e}`);
      }

      return null;
    }

    async getAdmisionesAbiertasCreacion(codigo: string, fechaInicial:number, fechaFinal: number,
      sedes: string, usuariosRealiza: string, usuariosModifica: string) {
        try {
          const request = await this.requestUrl.getRequest(
            'admision/abiertas-creacion',
            [ codigo,
            {
              'fechaInicial' : fechaInicial,
              'fechaFinal' : fechaFinal,
              'sedes' : sedes,
              'usuariosRealiza' : usuariosRealiza,
              'usuariosModifica' : usuariosModifica
            }]
          )
          return request;
        } catch(e) {
          console.error(`ServicioAdmisionesAbiertasService.getAdmisionesAbiertasCreacion() : ${e}`);
        }

        return null;
    }

  async getMovimientoPacienteByRangoFecha(codigo: string, ln_unco_sede: number, ln_fec_ini: number, ln_fec_fin: number) {

    try {
      return await this.requestUrl.getRequest(
        'admision/movimiento-paciente-x-rango-fechas',
        [ codigo,
          {
            ln_unco_sede,
            ln_fec_ini,
            ln_fec_fin
          }]
      );
    } catch (e) {
      console.error(`ServicioAdmisionesAbiertasService.getMovimientoPacienteByRangoFecha() : ${e}`);
    }
  }

  async getRelacionesAdmisiones(codigoBaseDatos: string, param: any) {
    try {
      return await this.requestUrl.getRequest(
        'admision/relacion-admisiones',
        [codigoBaseDatos, param]
      );
    } catch (e) {
      console.error(`ServicioAdmisionesAbiertasService.getRelacionesAdmisiones() : ${e}`);
    }
  }
}
export interface ReporteAdmisionEntity {
  codigo ?: string;
  uncoAdmision ?: number;
  uncoLogin ?: number;
  uncoSede ?: number;
}
export interface AdmisionEntity {
  unco ?: number;
  consecutivo ?: number;
  prefijo ?: string;
  observacion ?: string;
  fechaAdmision ?: number;
  fechaInicioServicio ?: number;
  fechaFinalServicio ?: number;
  fechaCreacion ?: number;
  afiliado ?: AfiliadoEntity;
  diagnosticoIngreso ?: DiagnosticoEntity;
  usuarioRealiza ?: LoginEntity;
  admisionesEmpresas ?: AdmisionesEmpresaEntity[];
}
interface LoginEntity {
  unco ?: number;
  usuario ?: string;
  descripcion ?: string;
  nombreUsuario ?: string;
}
interface AfiliadoEntity {
  unco ?: number;
  primerNombre ?: string;
  segundoNombre ?: string;
  primerApellido ?: string;
  segundoApellido ?: string;
  fechaNacimiento ?: number;
  tipoDocumento ?: string;
  numeroIdentificacion ?: string;
  codigoSexo ?: string;
  direccion ?: string;
  celular ?: string;
  telefono ?: string;
  email ?: string;
  nombreResponsable ?: string;
  direccionResponsable ?: string;
  telefonoResponsable ?: string;
  municipio ?: string;
  barrio ?: string;
  tipoAfiliado ?: string;
  estrato ?:string;
  edad ?: EdadEntity;
}
export interface AdmisionesEmpresaEntity {
  unco ?: number;
  empresa ?: EmpresaEntity;
  admisionesPuntoAtencion ?: AdmisionesPuntoAtencionEntity[];
}
export interface AdmisionesPuntoAtencionEntity {
  unco ?: number;
  sedePuntoAtencion ?: SedePuntoAtencionEntity;
  admisionesServicioDetalle ?: AdmisionesServicioDetalleEntity[];
}

export interface AdmisionesServicioDetalleEntity {
  unco ?: number;
  cantidad ?: number;
  numeroAutorizacion ?: string;
  procedimiento ?: ProcedimientoEntity;
  profesionalRealiza ?: ProfesionalEntity;
}
interface ProfesionalEntity {
  unco ?: number;
  nombres ?: string;
  apellidos ?: string;
  registroMedico ?: any;
  telefono ?: any;
  direccion ?: any;
  tipoDocumento ?: any;
}
interface ProcedimientoEntity {
  unco ?: number;
  codigo ?: number;
  codigoProcedimiento ?: string;
  descripcion ?: string;
}
interface SedePuntoAtencionEntity {
  puntoAtencion ?: PuntoAtencionEntity;
}
interface PuntoAtencionEntity {
  unco ?: number;
  tipo ?: number;
  descripcion ?: string;
}
interface EmpresaEntity {
  unco ?: number;
  direccion ?: string;
  descripcionCorta ?: string;
  descripcionLarga ?: string;
  numeroIdentificacion ?: string;
  telefonoPbx ?: string;
  fax ?: string;
  telefonoMovil ?: string;
  tipoDocumento ?: TipoDocumentoEntity;
}
interface TipoDocumentoEntity {
  unco ?: number;
  codigo ?: string;
  descripcion ?: string;
}
interface DiagnosticoEntity {
  unco ?: number;
  codigoDiagnostico ?: string;
  descripcion ?: string;
}

export interface EdadEntity {
  anos : number;
  meses : number;
  dias : number;
}

export interface SuministroEntity {
  unco: number;
  valorUnitario: number;
  cantidad: number;
  codigo: number;
  descripcion: string;
  numeroSolicitud: number;
  fechaCreacion: Date;
}

export interface ConceptosEntity {
  unco: number;
  descripcion: string;
  signo: string;
  valor: number;
}

export interface SuministrosAgrupadosEntity {
  [usuario: string]: SuministroEntity[]
}

export interface ReportAdmisionesAbiertasEntity{
  codigo ?: string;
  fechaInicial ?: number;
  fechaFinal ?: number;
  sedes ?: string;
  rolesRealiza ?: string;
  rolesModifica ?: string;
  usuariosRealiza ?: string;
  usuariosModifica ?: string;
  uncoLogin ?: number;
  uncoSede ?: number;
}

export interface AdmisionAbiertaEntity {
  consecutivo: number;
  uncoEmpresa: number;
  uncoSede: number;
  uncoPuntoAtencion: number;
  fecha: number;
  fechaInicial: number | undefined;
  fechaFinal: number | undefined;
  fechaCreacionAdmision: number | undefined;
  empresa: string;
  numeroIdentificacion: string;
  paciente: string;
  sede: string;
  puntoAtencion: string;
  usuarioModificacion: string;
  usuarioRealiza: string;
  estadoHistoria: string;
  estadoAdmision: string;
}

export interface AgrupacionSedeAdmisionAbiertaEntity {
  unco: number;
  sede: string;
  datos: AdmisionAbiertaEntity[];
}
